<ion-header class="modalHeader">
  <ion-toolbar mode="ios">
    <ion-title></ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()">
        <fa-icon [icon]="faChevronLeft"></fa-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding-top" fullscreen>
  <!-- Beaucoup de wrapping, mais les composants tuent le layout flex sinon-->
  <div class="content-wrapper">
    <div class="slides-wrapper">
      <swiper-container pager="true" [modules]="swiperModules" [initialSlide]="startIndex" [speed]="300" #slides>
        @switch (deletableMode) {
          @case (true) {
            @for (url of internalUrlsWithoutDeletedOnes(); track url) {
              <swiper-slide>
                <div class="swiper-zoom-container">
                  <img [src]="url.webPath ?? '' | safeUrl" alt="joined picture" />
                </div>
              </swiper-slide>
            }
          }
          @case (false) {
            @for (url of externalUrls; track url) {
              <swiper-slide>
                <div class="swiper-zoom-container">
                  <img [src]="url" alt="joined picture" />
                </div>
              </swiper-slide>
            }
          }
        }
      </swiper-container>
    </div>
    @if (deletableMode) {
      <div class="button-wrapper">
        <ion-button (click)="presentAlertConfirmDelete()" class="ion-margin-bottom" expand="block" color="danger">
          <fa-icon [icon]="faTrash"></fa-icon><span [translate]="'gallery.deletePhoto'"></span>
        </ion-button>
      </div>
    }
  </div>
</ion-content>
